"use client";

import { ReactNode } from 'react';
import { useQLHV } from '../../../contexts/QLHVContext';

interface LayoutProps {
    onClose: () => void
    isSidebarOpen: boolean,
    children: ReactNode,
    isEmbedded?: boolean,
    customStyle?: React.CSSProperties,
    customClass?: string
}

export default function LayoutDefault({ children, isSidebarOpen, isEmbedded = false, customStyle, customClass }: LayoutProps) {
    const { isQLHVMode } = useQLHV();
    const sidebarWidth = 320 // w-80 = 320px (20rem)
    // Nếu là chế độ QLHV, luôn tính leftPosition = sidebarWidth
    // Nếu không phải QLHV, tính theo isSidebarOpen
    const leftPosition = isQLHVMode ? sidebarWidth : (isSidebarOpen ? sidebarWidth : 15)

    if (isEmbedded) {
        return (
            <div className="relative w-full h-full z-35 bg-white overflow-auto">
                {children}
            </div>
        );
    }

    return (
        <div
            className={`fixed shadow-2xl z-35 transition-all duration-300 bg-white ${customClass || ''}`}
            style={{
                left: `${leftPosition}px`,
                width: `calc(100vw - ${leftPosition}px)`,
                overflow: 'auto',
                ...(isQLHVMode ? {
                    top: 0,
                    height: '100dvh',
                } : {
                    top: '49.4%',
                    transform: 'translateY(-46%)',
                    height: `calc(101dvh - 100px)`,
                    borderRadius: '12px',
                }),
                ...customStyle
            }}
        >

            {children}
        </div>
    )
}